export default __webpack_public_path__ + "static/media/logo.da828656.png";